<template>
  <div>
    <div class="pdbot6">
      <el-row class="mt10">
        <el-col :span="2">
          <div class="fb" style="line-height: 30px">服务对象：</div>
        </el-col>
        <el-col :span="20">
          <div class="listitem">
            <span v-for="item in finterserviceObj" :key="item.id" :class="item.id==selectObjid?'active':''"
              @click="selectObjitem(item)">
              {{ item.label }}
            </span>
          </div>
        </el-col>
        <el-col v-if="serviceObj.length > 10" :span="2" class="f_gray tr">
          <div style="cursor: pointer;" @click="seemoreServiceObj">
            更多<i v-if="listflag1" class="el-icon-arrow-down"></i>
            <i v-else class="el-icon-arrow-right"></i>
          </div>
        </el-col>
      </el-row>

      <el-row class="mt10">
        <el-col :span="2">
          <div class="fb" style="line-height: 30px">服务类别：</div>
        </el-col>
        <el-col :span="20">
          <div class="listitem">
            <span v-for="item in finterserviceType" :key="item.id" :class="item.id==selectTypeid?'active':''"
              @click="selectTypeitem(item)">
              {{ item.label }}
            </span>
          </div>
        </el-col>
        <el-col v-if="serviceType.length > 10" :span="2" class="f_gray tr">
          <div style="cursor: pointer;" @click="seemoreServiceType">
            更多<i v-if="listflag2" class="el-icon-arrow-down"></i>
            <i v-else class="el-icon-arrow-right"></i>
          </div>
        </el-col>
      </el-row>

      <el-row class="mt10">
        <el-col :span="2">
          <div class="fb" style="line-height: 30px">服务部门：</div>
        </el-col>
        <el-col :span="20">
          <div class="listitem">
            <span v-for="item in finterserviceDepartment" :key="item.id"
              :class="item.id==selectDepartmentid?'active':''" @click="selectDepartmentitem(item)">
              {{ item.label }}
            </span>
          </div>
        </el-col>
        <el-col v-if="serviceDepartment.length > serviceDepartmentMaxLength" :span="2" class="f_gray tr">
          <div style="cursor: pointer;" @click="seemore">
            更多<i v-if="listflag3" class="el-icon-arrow-down"></i>
            <i v-else class="el-icon-arrow-right"></i>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-row>
      <el-col :span="4" v-for="item in serviceList" :key="item.id">
        <div class="iconbox" @click="toinfor(item.id)">
          <el-row>
            <el-col :span="8">
              <!-- <i style="font-size: 40px;" :class="item.icon"></i> -->
               <i class="icon iconfont" :class="'icon-'+item.icon" style="font-size:40px;color: #3cba1a;"></i>
              <!-- <svg class="icon svg-icon" aria-hidden="true">
                  <use :xlink:href="'#icon-'+item.icon"></use>
                </svg> -->
            </el-col>
            <el-col :span="16" class="icontext"> {{item.serviceName}} </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    </div> 
    <div v-if="serviceList.length==0"  style="height:450px"  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
    </div>
   
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import "../static/css/my.css";
import {  queryService,queryServiceTabList,getDictByTypeCode } from '@/api/serviceHome'
export default {
  name: "serviceList",
  data() {
    return {
      serviceDepartmentMaxLength:7, // 服务部门默认展示7-1个
      loading:true,
      selectObjid: '-1',
      selectTypeid: '-1',
      selectDepartmentid: '-1',
      useRange: '',
      selectTypeName: '',
      mainDept: '',
      serviceList: [],
      listflag1: false,
      serviceObj: [
        { label: "全部", id: "-1" },
        { label: "学生", id: "0" },
        { label: "教职工", id: "1" },
        { label: "校友", id: "2" },
        { label: "访客", id: "3" },
      ],
      listflag2: false,
      serviceType: [
        { label: "全部", id: "-1" },
      ],
      listflag3: false,
      serviceDepartment: [
        { label: "全部", id: "-1" },
      ],
    };
  },
  computed: {
    //服务对象展示的数据
    finterserviceObj() {
      if (this.listflag1) {
        return this.serviceObj;
      } else {
        return this.serviceObj.filter((item, index) => {
          if (index < 10) return item; //默认展示10个
        });
      }
    },
    //服务类别展示的数据
    finterserviceType() {
      if (this.listflag2) {
        return this.serviceType;
      } else {
        return this.serviceType.filter((item, index) => {
          if (index < 10) return item; //默认展示10个
        });
      }
    },
    //服务部门展示的数据
    finterserviceDepartment() {
      if (this.listflag3) {
        return this.serviceDepartment;
      } else {
        return this.serviceDepartment.filter((item, index) => {
          if (index <this.serviceDepartmentMaxLength) return item; //
        });
      }
    },
  },
  mounted() {
    if(window.outerWidth>1366){
      this.serviceDepartmentMaxLength=10
    }else{
      this.serviceDepartmentMaxLength=7
    }

    if (this.$route.query.typeid){
      this.select()
      return
    }
    this.getServiceTabDept()
    this.getServiceTabType()
    // this.selectObjid=this.$route.query.id
    this.getServiceByType()

  },
  methods: {
    // 根据不同服务对象、类别、部门查询服务
    async getServiceByType() {
      this.serviceList =[]
      this.loading=true

      let searchData = [{
        name: 'like_f2',
        value: this.selectObjid==-1?'':this.selectObjid
      }, {
        name: 'eq_serviceType',
        value: this.selectTypeid==-1?'':this.selectTypeid
      }, {
        name: 'eq_mainDept',
        value: this.mainDept
      },{
        name: 'eq_useState',
        value: 1
      }
      ]
      let params = {
        searchData: JSON.stringify(searchData),
        pageIndex: 1,
        pageSize: 100,
        sortField: 'serviceSort',
        sortOrder: 'ASC'
      }
      const data = await queryService(params)
      this.serviceList = data.data
      this.loading=false
    },
    //选中 某个服务类别
    selectTypeitem(select) {
      this.selectTypeid = select.id
      this.getServiceByType()
    },
    //选中 某个服务对象
    selectObjitem(select) {
      this.selectObjid = select.id
      this.getServiceByType()
    },
    //选中 某个部门
    selectDepartmentitem(select) {
      this.selectDepartmentid = select.id
      this.mainDept = select.label
      if (select.id == -1) {
        this.mainDept = ''
      }
      this.getServiceByType()
    },
     //查询 所有服务部门
     async getServiceTabDept() {
      const data = await queryServiceTabList()
      if (data.msgCode == 0) {
        if (data.data != null) {
          data.data.forEach((item, index) => {
            let type = {
              label: item,
              id: index + 1
            }
            this.serviceDepartment.push(type)
          })
        }

      }
    },
     //查询 所有服务类别
     async getServiceTabType() {
      const data = await getDictByTypeCode('SERVICE_TYPE')
      if (data.msgCode == 0) {
        if (data.data != null) {
          data.data.forEach((item) => {
            let type = {
              label: item.dictname,
              id: item.dictcode
            }
            this.serviceType.push(type)
          })
        }

      }
    },
    seemoreServiceObj() {
      this.listflag1 = !this.listflag1;
    },
    seemoreServiceType() {
      this.listflag2 = !this.listflag2;
    },
    seemore() {
      this.listflag3 = !this.listflag3;
    },
    toinfor(id) {
      let select = {
        'id':id,
        'page':1,
        'typeid':this.selectTypeid,
        'objid':this.selectObjid,
        'departmentid':this.selectDepartmentid,
        'mainDept':this.mainDept
      }
      this.$router.push({
        path:"/ServiceInfor",
        query:{
          ...select
        }
      });
    },
    async select(){
      await this.getServiceTabDept()
      await this.getServiceTabType()
      // this.selectObjid=this.$route.query.id
      await this.getServiceByType()
      this.selectTypeid = this.$route.query.typeid
      this.selectObjid = this.$route.query.objid
      this.selectDepartmentid = this.$route.query.departmentid
      this.mainDept = this.$route.query.mainDept
      this.getServiceByType()
    }
  },
  components: {
    // HelloWorld
  },
};
</script>
<style scoped>
.iconbox {
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 15px 6px;
  /*box-shadow:0px 0px 6px 2px rgba(0,0,0,0.1);*/
  margin: 10px;
  background: #f5faf8;
  cursor: pointer;
}

.iconbox:hover {
  background: rgba(194, 230, 211, 0.3);
}

.icontext {
  height: 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
}

.listitem span {
  display: block;
  float: left;
  padding: 5px 10px;
  cursor: pointer;
}

.listitem span.active {
  background: #008a2c;
  color: #fff;
  border-radius: 5px;
}
</style>